import { jsx as _jsx } from "react/jsx-runtime";
import { isStringInArrayCaseInsensitive } from '../../../../../utils';
import { AccountRole } from '../../../../../types/AccountRole.enum';
import { MobileLinksList } from './MobileLinksList';
export const MyAccountSubNavigation = ({ accountRoles, userNick, onLogout, }) => {
    const MY_ACCOUNT_LINKS = [
        {
            url: `/${userNick}/profile`,
            name: 'My Profile',
        },
        {
            url: '/following',
            name: 'Following',
        },
        {
            url: '/order-history',
            name: 'My Orders',
        },
        {
            url: '/settings',
            name: 'Account settings',
        },
        {
            url: '/auth/logout',
            name: 'Log out',
            onClick: onLogout,
        },
    ];
    if (isStringInArrayCaseInsensitive(accountRoles, AccountRole.SHOP)) {
        MY_ACCOUNT_LINKS.splice(1, 0, { url: '/earnings', name: 'My Earnings' });
        MY_ACCOUNT_LINKS.splice(3, 0, { url: '/shop-handbook', name: 'Displate Shop Handbook' });
    }
    return _jsx(MobileLinksList, { links: MY_ACCOUNT_LINKS }, void 0);
};
//# sourceMappingURL=MyAccountSubNavigation.js.map